'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/label-has-associated-control */
import clsx from 'clsx';
import { get, useFormState, } from 'react-hook-form';
import FormError from '../FormError';
import FormLabel from '../FormLabel';
function CheckedInput({ className, name, disabled, onChange, checked, value, register, type = 'checkbox', }) {
    const onChangeHandler = onChange &&
        ((event) => {
            onChange(event.target.checked, event.target.value);
        });
    const inputProps = {
        name,
        disabled,
        onChange: onChangeHandler,
        checked,
        value,
        type,
        ...register,
    };
    return (_jsx("input", { className: clsx('h-4 w-4 cursor-pointer border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500', { 'cursor-not-allowed opacity-50': disabled }, { rounded: type === 'checkbox' }, className), ...inputProps }));
}
CheckedInput.Labelled = function SelectInputLabelled({ label, className, error, horizontalLabel, renderOnPageBackground = false, ...rest }) {
    if (horizontalLabel) {
        return (_jsxs("div", { children: [_jsxs("label", { className: clsx('flex cursor-pointer items-center', className), children: [_jsx(CheckedInput, { ...rest }), label && (_jsx(FormLabel, { className: "ml-2 mt-2 w-full", renderOnPageBackground: renderOnPageBackground, children: label }))] }), error && _jsx(FormError, { children: error })] }));
    }
    return (_jsxs("label", { className: clsx('block', className), children: [label && (_jsx(FormLabel, { renderOnPageBackground: renderOnPageBackground, children: label })), _jsx(CheckedInput, { ...rest }), error && _jsx(FormError, { children: error })] }));
};
CheckedInput.LabelledController = function CheckedInputLabelledController({ control, name, noError, ...rest }) {
    const { errors } = useFormState({ control, name });
    const error = get(errors, name);
    return (_jsx(CheckedInput.Labelled, { register: control.register(name), error: noError ? undefined : error?.message, ...rest }));
};
export { CheckedInput };
//# sourceMappingURL=CheckedInput.js.map